module.exports = __webpack_public_path__ + "static/media/netstorage/fonts/factoria_ultra-webfont.woff";